export namespace ActivityLogEnum {
  export enum Scope {
    ACCOUNT = 'ACCOUNT',
    PURCHASE = 'PURCHASE',
    WALLET = 'WALLET',
  }

  export enum ActionValue {
    /** Account */
    CUSTOMER__REGISTER = 'CUSTOMER.REGISTER',
    CUSTOMER__SIGN_IN = 'CUSTOMER.SIGN_IN',
    CUSTOMER__SIGN_OUT = 'CUSTOMER.SIGN_OUT',
    CUSTOMER__RESET_PASSWORD = 'CUSTOMER.RESET_PASSWORD',
    CUSTOMER__UPDATE_PROFILE = 'CUSTOMER.UPDATE_PROFILE',
    CUSTOMER__UPDATE_PROFILE_PICTURE = 'CUSTOMER.UPDATE_PROFILE_PICTURE',
    CUSTOMER__CHANGE_PASSWORD = 'CUSTOMER.CHANGE_PASSWORD',
    /** Transaction */
    CUSTOMER__PURCHASE_QR = 'CUSTOMER.PURCHASE_QR',
    CUSTOMER__PURCHASE_CREDIT_CARD = 'CUSTOMER.PURCHASE_CREDIT_CARD',
    CUSTOMER__RECEIVE_GIVEAWAY_QR = 'CUSTOMER.RECEIVE_GIVEAWAY_QR',
    /** Wallet & My reward */
    CUSTOMER__TRANSFER_REWARD_COIN = 'CUSTOMER.TRANSFER_REWARD_COIN',
    CUSTOMER__RECEIVE_REWARD_COIN = 'CUSTOMER.RECEIVE_REWARD_COIN',
    CUSTOMER__USE_REWARD_COIN = 'CUSTOMER.USE_REWARD_COIN',
  }

  export const ActionLabel = Object.freeze({
    CUSTOMER__REGISTER: {
      value: ActionValue.CUSTOMER__REGISTER,
      label: 'Register',
    },
    CUSTOMER__SIGN_IN: {
      value: ActionValue.CUSTOMER__SIGN_IN,
      label: 'Sign In',
    },
    CUSTOMER__SIGN_OUT: {
      value: ActionValue.CUSTOMER__SIGN_OUT,
      label: 'Sign Out',
    },
    CUSTOMER__RESET_PASSWORD: {
      value: ActionValue.CUSTOMER__RESET_PASSWORD,
      label: 'Reset Password',
    },
    CUSTOMER__UPDATE_PROFILE: {
      value: ActionValue.CUSTOMER__UPDATE_PROFILE,
      label: 'Update Profile',
    },
    CUSTOMER__UPDATE_PROFILE_PICTURE: {
      value: ActionValue.CUSTOMER__UPDATE_PROFILE_PICTURE,
      label: 'Update Profile Picture',
    },
    CUSTOMER__CHANGE_PASSWORD: {
      value: ActionValue.CUSTOMER__CHANGE_PASSWORD,
      label: 'Change Password',
    },
    CUSTOMER__PURCHASE_QR: {
      value: ActionValue.CUSTOMER__PURCHASE_QR,
      label: 'Purchase By QR Code',
    },
    CUSTOMER__PURCHASE_CREDIT_CARD: {
      value: ActionValue.CUSTOMER__PURCHASE_CREDIT_CARD,
      label: 'Purchase By Credit Card',
    },
    CUSTOMER__RECEIVE_GIVEAWAY_QR: {
      value: ActionValue.CUSTOMER__RECEIVE_GIVEAWAY_QR,
      label: 'Receive Giveaway QR Code',
    },
    CUSTOMER__TRANSFER_REWARD_COIN: {
      value: ActionValue.CUSTOMER__TRANSFER_REWARD_COIN,
      label: 'Transfer Product',
    },
    CUSTOMER__RECEIVE_REWARD_COIN: {
      value: ActionValue.CUSTOMER__RECEIVE_REWARD_COIN,
      label: 'Receive Product',
    },
    CUSTOMER__USE_REWARD_COIN: {
      value: ActionValue.CUSTOMER__USE_REWARD_COIN,
      label: 'Use Product',
    },
  });

  export enum SourceModel {
    CUSTOMERS = 'customers',
  }

  export enum TargetModel {
    CUSTOMERS = 'customers',
    COURSES = 'courses',
  }

  export const ActivityValueAndDisplayMappingList = Object.values(ActivityLogEnum.ActionLabel);
  export const ActivityValueList = ActivityValueAndDisplayMappingList.map((data) => data.value);
}
